module.exports = __webpack_public_path__ + "img/logo4.b195e6ea.png";